import SuspenseRoute from "@/components/SuspenseRoute";
import useAuth from "@/hooks/useAuth";
import AppLayout from "@/layouts/AppLayout";
import LogoutPage from "@/pages/auth/LogoutPage";
import ErrorsPage from "@/pages/errors/ErrorsPage";
import ContactUsPage from "@/pages/contact-us/ContactUsPage";
import { lazyImport } from "@/utils/functions";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";

const AuthPage = lazyImport(() => import("@/pages/auth/AuthPage"));
const PrivateRoutes = lazyImport(() => import("@/routes/PrivateRoutes"));

const AppRoute = () => {
  const { user } = useAuth();
  return (
    <BrowserRouter basename={import.meta.env.BASE_URL}>
      <Routes>
        <Route element={<AppLayout />}>
          <Route path="error/*" element={<ErrorsPage />} />
          <Route path="contact-us/*" element={<ContactUsPage />} />
          <Route path="logout" element={<LogoutPage />} />
          {user ? (
            <>
              <Route
                path="/*"
                element={
                  <SuspenseRoute>
                    <PrivateRoutes />
                  </SuspenseRoute>
                }
              />
              <Route index element={<Navigate to="/dashboard" />} />
            </>
          ) : (
            <>
              <Route
                path="auth/*"
                element={
                  <SuspenseRoute>
                    <AuthPage />
                  </SuspenseRoute>
                }
              />
              <Route path="*" element={<Navigate to="/auth" />} />
            </>
          )}
        </Route>
      </Routes>
    </BrowserRouter>
  );
};

export default AppRoute;
